<script setup lang="ts">
import type { TArticlessSidebarItem } from '~/components/entity/articles/sidebar-item/types'
defineOptions({ inheritAttrs: false })
const props = defineProps<TArticlessSidebarItem>()

const formattedDate = computed(() =>
  props.publication_datetime ? useDateTimeFormat(props.publication_datetime) : ''
)
</script>

<template>
  <article class="relative space-y-2.5 overflow-hidden">
    <NuxtImg
      v-if="props.picture"
      :src="props.picture"
      width="350"
      height="210"
      :alt="props.title"
      class="w-full rounded-lg"
      format="avif,webp"
      :loading="props.eagerLoading ? 'eager' : 'lazy'"
    />
    <header class="flex items-center justify-between">
      <div v-if="props.category" class="flex gap-1.5">
        <Badge rounded="full" class="bg-blue-50 font-normal text-gray-700">{{
          props.category
        }}</Badge>
      </div>
      <span v-if="formattedDate" class="text-xs text-gray-500">{{ formattedDate }}</span>
    </header>
    <Heading tag="h4" class="font-sans text-[1rem] font-semibold leading-5">
      <NuxtLinkLocale
        :to="props.url"
        class="after:absolute after:inset-0 hover:underline focus-visible:ring-0"
        >{{ props.title }}</NuxtLinkLocale
      >
    </Heading>
    <p class="text-sm">{{ props.summary }}</p>
  </article>
</template>
